import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PromoService } from './promo.service';
import { Observable } from 'rxjs';

/**
 * Componente encargado de gestionar la introducción y validación de códigos promocionales.
 *
 * Muestra un campo de texto para ingresar el código, e íconos para indicar validez.
 * También emite el resultado de la validación al componente padre.
 */
@Component({
  selector: 'app-promo',
  template: `
  <ng-container  *ngIf="isPromoAvailable">
    <h4>{{ "COMMON.PROMO.TITLE" | translate }}</h4>
    <mat-label>{{ "COMMON.PROMO.DESC" | translate }}</mat-label>
    <ng-container *ngIf="promoValid">
      <p class="text-xs italic" *ngIf="promo_quantity == 0 || promo_quantity == null">
        {{ "COMMON.PROMO.DESC_SUB_TOTAL" | translate }}
      </p>
      <p class="text-xs italic" *ngIf="promo_quantity > 0">
        {{ "COMMON.PROMO.DESC_SUB" | translate:{ quantity: promo_quantity } }}
      </p>
    </ng-container>

    <mat-form-field class=" w-full lg:w-[100%] my-4 mr-4 flex flex-row">
      <mat-label class="w-full">{{ "COMMON.PROMO.LABEL" | translate }}</mat-label>
      <input matInput [(ngModel)]="promoCode" (ngModelChange)="onPromoCodeChange($event)" class="!w-[80%]"/>
      <mat-icon class="text-light-red material-icons-outlined float-end w-fit" *ngIf="promoCode != '' && !promoValid">error</mat-icon>
      <mat-icon class="text-green-700 material-icons-outlined float-end w-fit" *ngIf="promoCode != '' && promoValid">check_circle</mat-icon>
    </mat-form-field>
  </ng-container>
  `
})
export class PromoComponent implements OnInit {
  /**
   * Producto asociado a la promo. Utilizado para verificar si hay promociones activas.
   */
  @Input() product: string = '';

  /**
   * Indica si hay promociones disponibles para el producto.
   */
  isPromoAvailable: boolean = false;

  /**
   * Código promocional ingresado por el usuario.
   */
  promoCode: string = '';

  /**
   * Estado de validez del código promocional.
   */
  promoValid: boolean = false;

  /**
   * Cantidad de promociones disponibles (si aplica).
   */
  promo_quantity = 0;

  /**
   * Evento que emite el objeto de la promoción validada al componente padre.
   */
  @Output() promo: any = new EventEmitter<any>();

  /**
   * @param promoService Servicio encargado de verificar la existencia y validez de promociones.
   */
  constructor(private promoService: PromoService) { }

  /**
   * Método del ciclo de vida Angular.
   * Verifica si hay promociones activas para el producto al cargar el componente.
   */
  async ngOnInit(): Promise<void> {
    this.isPromoAvailable = await this.promoService.isPromosActive(this.product);
  }

  /**
   * Se ejecuta cuando el valor del código promocional cambia.
   * Verifica la validez del código y actualiza el estado del componente.
   *
   * @param value El nuevo código promocional ingresado.
   */
  async onPromoCodeChange(value: string) {
    if (value.trim()) {
      const promo = await this.promoService.validatePromoCode(value);
      console.log(promo);
      this.promoValid = promo.promos.length > 0;
      this.promo_quantity = this.promoValid ? promo.promos[0].quantity : 0;
      this.promo.emit(promo);
    }
  }
}
